import usePanel from '@databases/panel/usePanel';
import { useCollabManager } from '@databases/utils/hooks/useCollabManager';
import { useEffect } from 'react';

const SetupPanelListener = ({ contentId }: { contentId: string }) => {
  const { showPanel, hidePanel, isPanelVisible } = usePanel();

  const collabManager = useCollabManager(contentId);
  const wasCreatedThisSession = collabManager?.wasCreatedThisSession;

  useEffect(() => {
    if (isPanelVisible('DatabaseSetupPanel')) {
      hidePanel();
    }

    if (wasCreatedThisSession) {
      showPanel('DatabaseSetupPanel');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SetupPanelListener;
